import { trancateText } from 'utils/utils';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

const TextEllipsize = ({ value, length }) => (
  <Tooltip title={value}>
    <span style={{ height: 'max-content' }}>{trancateText(value, length)}</span>
  </Tooltip>
);

TextEllipsize.propTypes = {
  value: PropTypes.string,
  length: PropTypes.number
};

export default TextEllipsize;
